module.exports = __webpack_public_path__ + "static/media/send-backward.e88dbfce.svg";